import { render, staticRenderFns } from "./KeiAvbAnswerTable.vue?vue&type=template&id=f3336866"
import script from "./KeiAvbAnswerTable.vue?vue&type=script&lang=js"
export * from "./KeiAvbAnswerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports